import {createFeatureSelector, createSelector} from "@ngrx/store";
import {usersFeatureKey, UsersState} from "../reducers/users.reducer";

const usersFeatureState = createFeatureSelector<UsersState>(usersFeatureKey);

export const getUsers = createSelector(
  usersFeatureState,
  state => state.users ?? []
);

export const getTotalUsers = createSelector(
  usersFeatureState,
  state => state.totalUsers ?? null
);

export const getLoggedInUser = createSelector(
  usersFeatureState,
  state => state.loggedInUser ?? null
);

export const getUserList = createSelector(
  usersFeatureState,
  state => state.userList ?? []
);

export const getSelectedUserId = createSelector(
  usersFeatureState,
  state => state.selectedUserId ?? ""
);

export const getSelectedUser = createSelector(
  usersFeatureState,
  state => state.selectedUser ?? null
);

export const selectUserDisabled = createSelector(
  usersFeatureState,
  state => state.userDisabled ?? false
);
